import styled from 'styled-components'

const ToolboxItemIconUi = styled.div`
  height: 40px;
  font-size: 40px;
  color: #acc9de;
`

export default ToolboxItemIconUi
